<div
  *ngIf="!disableBackdrop"
  class="backdrop"
  aria-hidden="true"
  (click)="backdrop.next()"
></div>

<div
  [class.widthFixedDialogForIE]="isIEBrowser"
  [class.fadeIn]="!disableAnimation"
  class="dialog-container animated nes-rounded"
  role="dialog"
  tabindex="0"
  aria-label="Dialog window"
>
  <ng-content></ng-content>

  <button
    *ngIf="!disableClose"
    data-cy="dialog_close"
    class="closeButton overlay__close"
    (click)="closeDialog()"
    aria-label="Close dialog"
  >
    <span class="icon"></span>
  </button>
</div>